import CodeBlock from "../../common/code_block";
import ErrorCodesLink from "../../common/ErrorCodesLink";
import EnvelopeRows from "../../common/EnvelopeRows";
import HeaderWithTag from "../../common/header_with_tag";
import { ICredentials } from "../../types/types"
import { Link } from 'react-router-dom';
import { HOST_API_URL } from "../../config";
import TryGetBanksByCountry from "./try";


const responseCode = `{
  "statusCode": 200,
  "message": "Success",
  "errorCode": null,
  "data": [
    {
      "name": "AliPay",
      "countryCode": "CN",
      "code": "3541",
      "agentId": "THC"
    },
    {
      "name": "UnionPay",
      "countryCode": "CN",
      "code": "2136",
      "agentId": "THC"
    }
  ]
}`;

function GetBanksByCountry() {
  return (
    <div className="page">
      <div className="app-content main-content mt-0">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <div>
                <h1 className="page-title">Get Banks By Country</h1>
              </div>
              <div className="ms-auto pageheader-btn">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="javascript:void(0);">Docs</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Get Banks By Country
                  </li>
                </ol>
              </div>
            </div>

            <div className="card overflow-hidden">
              <div className="row">
                <div className="col-md-7" style={{ position: "relative" }}>
                  <div className="card-body border-end p-0">
                    <div className="p-5">
                      <HeaderWithTag
                        headerText="Retrieve list of banks available for a specific country"
                        headerTag="description"
                      />
                      <p className="text-12">
                        <span className="badge badge-sm bg-blue text-white me-2">
                          GET
                        </span>
                        {HOST_API_URL}/Common/GetBanksByCountry?countryCode=CN
                      </p>
                      <p className="text-muted text-14" style={{ textAlign: "justify" }}>
                        Returns the list of banks supported for remittance payouts in the specified country.
                        Use this to populate bank selection options during transaction setup.
                      </p>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Query Parameters"
                          headerTag="parameters"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameters</th>
                                <th>Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>countryCode</td>
                                <td>string</td>
                                <td>ISO country code (e.g., CN for China). Required.</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p className="text-muted text-14 mb-0">
                          Omitting <code>countryCode</code>, or sending it empty, returns 400
                          with DPI-1000. An unknown code, or a country with no configured
                          banks, succeeds with <code>data: null</code>.
                        </p>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Response"
                          headerTag="response"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameters</th>
                                <th>Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <EnvelopeRows />
                              <tr>
                                <td>data[].name</td>
                                <td>string</td>
                                <td>Bank name</td>
                              </tr>
                              <tr>
                                <td>data[].countryCode</td>
                                <td>string</td>
                                <td>ISO country code</td>
                              </tr>
                              <tr>
                                <td>data[].code</td>
                                <td>string</td>
                                <td>Bank code to send as bankDetails.bankCode on a Bank payment</td>
                              </tr>
                              <tr>
                                <td>data[].agentId</td>
                                <td>string</td>
                                <td>Agent that services this bank; use it as receiver.destinationAgent</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={responseCode}
                          codeBlackText="Response Simple"
                          codeLanguage="json"
                        />
                      </div>

                      <ErrorCodesLink />
                    </div>
                  </div>
                </div>
                <div className="col-md-5 pt-5">
                  <h5 className="card-title text-primary">
                     Code Samples
                  </h5>

                  <TryGetBanksByCountry
                    codeBlackTitle="Request Simple"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GetBanksByCountry;